<template>
  <contract-discount-form
    description="Configura un descompte per a reserves fetes amb una anticipació determinada."
    :percentage="contractEarlyBookingDiscount"
    percentage-label="Introudeix el percentatge"
    percentage-description="Aquest percentatge s'aplicarà a l'import propietari"
    :days="contractEarlyBookingDiscountDuration"
    days-label="Introudeix la duració"
    days-description="Defineix els dies mínims d'anticipació"
    @cancel="cancel"
    @save="save"
  />
</template>

<script>
import ContractDiscountForm from "@/views/contracts/contract/components/ContractDiscountForm.vue";
import { notifyError } from "@/utils/methods";

export default {
  components: {
    ContractDiscountForm,
  },
  computed: {
    contract() {
      return this.$store.getters["contract/contract"];
    },
    contractEarlyBookingDiscount() {
      return this.contract?.earlyBookingDiscount || null;
    },
    contractEarlyBookingDiscountDuration() {
      return this.contract?.earlyBookingDiscountDuration || null;
    },
  },
  methods: {
    save(form) {
      this.$store.dispatch("app/setLoading", true);

      this.$store
        .dispatch("contract/updateContract", {
          uuid: this.contract.uuid,
          earlyBookingDiscount: form.percentage,
          earlyBookingDiscountDuration: form.days,
        })
        .then(() => {
          // TODO: log the contract update?
          this.$emit("updated");
        })
        .catch(() =>
          notifyError(
            "Error",
            "Hi ha hagut un error al intentar actualitzar el contracte"
          )
        )
        .finally(() => this.$store.dispatch("app/setLoading", false));
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>
